<template>
  <v-card class="card pa-4 " color="gray10" flat>
    <div class="d-flex title">
      <v-icon>$editList</v-icon>
      <h2 class="font-Light-16 ms-2 ">{{ accountData.name }}</h2>
    </div>

    <p class="font-Light-16 gray2--text my-6">
      {{ $t("corporateAccount.signCreate.confirmLegalAccountCreation") }}
    </p>

    <v-card class="card pa-4 mt-3" color="gray8" flat>
      <h2 class="font-Light-16">{{ terms.page_title }}</h2>
      <p
        class="mt-4 text-justify gray2--text"
        style="line-height: 30px; max-height: none; overflow: hidden;"
        v-html="displayedContent"
      ></p>
      <v-btn v-if="isLongText" @click="toggleExpand" text class="primary">
        {{ expanded ? "بستن" : "نمایش بیشتر" }}
      </v-btn>
    </v-card>

    <v-checkbox
      v-model="termsCheckBox"
      :ripple="false"
      class="custom-checkbox mt-10 text-right"
      hide-details
      dense
      :label="$t('corporateAccount.signCreate.acceptLegalAccountRules')"
    >
    </v-checkbox>

    <v-row class="">
      <v-col>
        <v-btn
          outlined
          x-large
          block
          outline
          color="primary"
          class="mt-16 px-16"
          @click="cancelDialog = true"
        >
          {{ $t("shared.cancel") }}
        </v-btn>
      </v-col>
      <v-col>
        <v-btn
          :disabled="!termsCheckBox"
          x-large
          block
          color="primary"
          class="mt-16 px-16"
          @click="signLegalAccount"
        >
          {{ $t("shared.confirm") }}
        </v-btn>
      </v-col>
    </v-row>

    <v-dialog v-model="cancelDialog" max-width="400">
      <v-card
        class="d-flex flex-column align-center justify-center pa-4 px-md-8 pt-md-16 pb-md-10 gray10"
      >
        <v-icon size="68" clr="var(--v-error-base)">$cancelOrder</v-icon>

        <span class="font-Bold-20 mt-6">{{
          $t("corporateAccount.signCreate.revokeLegalAccountPermission")
        }}</span>
        <p class=" font-Regular-17 gray2--text mt-6 text-center">
          {{
            $t(
              "corporateAccount.signCreate.revokeLegalAccountPermissionConfirmation"
            )
          }}
        </p>

        <v-btn x-large color="primary" @click="declineLegalAccount" block>
          {{
            $t(
              "corporateAccount.signCreate.revokeLegalAccountPermissionConfirmButton"
            )
          }}</v-btn
        >
        <v-btn
          x-large
          outlined
          color="primary"
          block
          class="mt-4"
          @click="cancelDialog = false"
        >
          {{ $t("shared.cancelAction") }}
        </v-btn>
      </v-card>
    </v-dialog>
  </v-card>
</template>

<script>
import legalService from "@/services/modules/legalService";
import { mapGetters } from "vuex";
import * as types from "@/store/types";
export default {
  data() {
    return {
      cancelDialog: false,
      terms: null,
      CA_ID: this.$route.query.CA_ID,
      termsCheckBox: false,
      accountData: null,

      expanded: false,
      limit: 300
    };
  },
  mounted() {
    const uuid = this.$route.query.CA_ID;
    if (uuid) {
      const data = this.getAccountById(uuid);
      if (data) {
        this.accountData = data;
      } else {
        this.$router.push("/legal-entity/manage/");
      }
    }
    legalService.getTerms().then(res => {
      this.terms = res.data.data;
    });
  },
  computed: {
    ...mapGetters({
      getAccountById: types.corporate.getters.GET_ACCOUNT_BY_UUID
    }),
    isLongText() {
      return this.terms.page_content.length > this.limit;
    },
    displayedContent() {
      if (this.expanded || !this.isLongText) {
        return this.terms.page_content;
      }
      return this.terms.page_content.substring(0, this.limit) + "...";
    }
  },
  methods: {
    signLegalAccount() {
      legalService
        .reviewLegalAccountByMember(this.CA_ID, {
          is_accepted: true
        })
        .then(() => {
          this.$router.push({
            path: "/legal-entity/manage",
            query: { CA_ID: this.CA_ID }
          });
        })
        .finally(() => {
          this.cancelDialog = false;
        });
    },
    declineLegalAccount() {
      legalService
        .reviewLegalAccountByMember(this.CA_ID, {
          is_accepted: false
        })
        .then(() => {
          this.$router.push({
            path: "/legal-entity/manage"
          });
        })
        .finally(() => {
          this.cancelDialog = false;
        });
    },
    toggleExpand() {
      this.expanded = !this.expanded;
    }
  }
};
</script>
